import { FormLabel, TextField, Typography, MenuItem } from "@mui/material";
import { useEffect } from "react";
import { ReservationRequest } from '../../types/common';

interface FormProps {
    data: ReservationRequest;
    setData: (data: ReservationRequest) => void;
    readonly?: boolean;
}

const MaterialTypes: Array<{ name: string, label: string }> = [
    {
        name: "stuehle", label: "Stühle"
    },
    {
        name: "tische", label: "Tische"
    },
    {
        name: "stellwaende", label: "Stellwände"
    },
    {
        name: "stehtische", label: "Stehtische"
    },
    {
        name: "tresen", label: "Tresen"
    },
    {
        name: "biergarnitur", label: "Bierzeltgarnituren (1 Tisch + 2 Bänke)"
    },
    {
        name: "kuehltruhen", label: "Kühltruhen"
    },
    {
        name: "becher", label: "Anzahl der Kisten (1 Kiste = 297 Becher à 0,4 l)"
    },
]

export default function MaterialInput(props: FormProps) {
    const { data, setData, readonly } = props;

    const allNames = MaterialTypes.map((material) => material.name);

    const updateData = (materialName: string, value: number) => {
        let newData = { ...data };
        newData.materials[materialName] = value;
        setData(newData);
    }

    const validate = (event: React.ChangeEvent<HTMLInputElement>) => {
        let name = event.target.name;
        let value = parseInt(event.target.value);

        if (isNaN(value)) {
            value = 0;
        }
        value = Math.max(0, value);

        if (name === "becher") {
            value = Math.min(1000, value);
        } else {
            value = Math.min(10, value);
        }
        updateData(name, value);
    }

    useEffect(() => {
        let newData = { ...data };
        allNames.forEach((name) => {
            if (!(name in newData.materials)) {
                newData.materials[name] = 0;
            }
        });
        setData(newData);
    }, []);

    return (
        <>
            <FormLabel sx={{ pb: 5 }}>Benötigte Materialien</FormLabel>
            {Object.keys(data.materials).map((name) => {
                const material = MaterialTypes.find((material) => material.name === name);

                if (!material) {
                    return null;
                }

                let stepSize = 1;

                if (name === "becher")
                    stepSize = 50;

                return (
                    <TextField
                        id="standard-number"
                        label={material.label}
                        key={material.name}
                        name={material.name}
                        select={name === "becher"} // Wenn Name 'becher' ist, wird es ein Dropdown
                        type={name === "becher" ? "text" : "number"} // Becher ist kein "number"-Input mehr
                        value={data.materials[material.name]}
                        inputProps={{ 
                            min: 0, 
                            style: { textAlign: 'right' }, 
                            readOnly: props.readonly, 
                            step: stepSize 
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant={props.readonly ? "filled" : "outlined"}
                        fullWidth
                        onChange={validate}
                        sx={{ mt: 2 }}
                    >
                        {name === "becher" ? [
                            <MenuItem key={0} value={0}>0 Kisten (keine)</MenuItem>,
                            <MenuItem key={1} value={297}>1 Kiste (297 Becher)</MenuItem>,
                            <MenuItem key={2} value={594}>2 Kisten (594 Becher)</MenuItem>,
                            <MenuItem key={3} value={891}>3 Kisten (891 Becher)</MenuItem>
                        ] : null}
                    </TextField>
                )
            })
            }
        </>
    );
}
